import { ADD_DEVICE as addDevice } from './addDevice';
import { DEFAULT_DEVICES as defaultDevices } from './default';
export const DEVICES = {
  defaultDevices,
  addDevice
};
